<script>
export default {
  name: 'ControlBar',
  props: {
    collapsable: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<template>
  <div :class="{
    'control-bar': true,
    'is-collapsable': collapsable
  }">
    <div v-if="$slots.primary" class="primary">
      <slot name="primary" />
    </div>

    <div v-if="$slots.secondary" class="secondary">
      <slot name="secondary" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.control-bar {
  display: flex;
  width: 100%;
  flex: 0 0 auto;
  margin-bottom: 2rem;

  .primary {
    flex: 1 1 auto;
    padding-right: .5rem;
    white-space: nowrap;
  }

  .secondary {
    flex: 1 0 auto;
    text-align: right;
    padding-left: .5rem;
    white-space: nowrap;
  }

  .primary,
  .secondary {
    > * {
      margin-left: 0;
    }

    > *:not(:last-child) {
      margin-right: 1rem;
    }
  }

  @include breakpoint('lg-and-down') {
    &.is-collapsable {
      display: block;
      margin-bottom: 1rem;
    }

    &.is-collapsable .primary {
      max-width: none;
      padding-right: 0;
      white-space: normal;
    }

    &.is-collapsable .secondary {
      max-width: none;
      text-align: left;
      padding-left: 0;
      white-space: normal;
    }

    &.is-collapsable .primary,
    &.is-collapsable .secondary {
      /deep/ .el-button,
      /deep/ .el-input {
        margin-bottom: 1rem;
      }

      /deep/ .el-button-group:first-child {
        margin-right: 1rem;
      }

      /deep/ .el-button-group:not(:first-child) {
        margin-left: 0;
        margin-right: 1rem;
      }
    }
  }

  @include breakpoint('sm-and-down') {
    &.is-collapsable {
      display: block;
      margin-bottom: 0;
    }
  }
}
</style>
